var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('pre',[_vm._v("          Build_"+_vm._s(_vm.BUILD_NUMBER)+", "+_vm._s(_vm.GIT_VERSION)+", "+_vm._s(_vm.env.NODE_ENV)+", "+_vm._s(_vm.env.VUE_APP_API)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }